import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/User Interface/sp-button";
import * as React from 'react';
export default {
  Content,
  React
};